import { render, staticRenderFns } from "./ProfitStatistics3.vue?vue&type=template&id=4d0b815e&scoped=true&"
import script from "./ProfitStatistics3.vue?vue&type=script&lang=js&"
export * from "./ProfitStatistics3.vue?vue&type=script&lang=js&"
import style0 from "./ProfitStatistics3.vue?vue&type=style&index=0&id=4d0b815e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0b815e",
  null
  
)

export default component.exports